import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e02eabc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "section-title" }
const _hoisted_7 = {
  key: 1,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_8 = { class: "section-title" }
const _hoisted_9 = {
  key: 3,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_10 = {
  key: 5,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_11 = { class: "ion-text-center ion-margin-top" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_cart_button = _resolveComponent("cart-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createVNode(_component_logo_img)
                ]),
                _: 1
              }),
              (!$setup.loadingCompanyInfo)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openBrowser($setup.companyInfo.websiteUrl)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.compass
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_cart_button)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          ($setup.loadingCompanyInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_slides, {
                key: 1,
                class: "banner-slides",
                pager: "true",
                options: $setup.bannerSlideOpts
              }, {
                default: _withCtx(() => [
                  ($setup.companyInfo.homeBanner1)
                    ? (_openBlock(), _createBlock(_component_ion_slide, { key: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "banner-img",
                            src: $setup.companyInfo.banner1Link
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.companyInfo.homeBanner2)
                    ? (_openBlock(), _createBlock(_component_ion_slide, { key: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "banner-img",
                            src: $setup.companyInfo.banner2Link
                          }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.companyInfo.homeBanner3)
                    ? (_openBlock(), _createBlock(_component_ion_slide, { key: 2 }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "banner-img",
                            src: $setup.companyInfo.banner3Link
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["options"])),
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              (!$setup.loadingProductCategories)
                ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                    key: 0,
                    mode: "md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment, {
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.categorySegmentChanged($event))),
                        scrollable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allProductCategories, (category) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              class: "product-category-btn",
                              mode: "md",
                              key: category.id,
                              value: category.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_avatar, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: category.imageLink
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_6, _toDisplayString($setup.t('HomePage.featuredProducts')), 1),
              ($setup.loadingProducts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_slides, {
                    key: 2,
                    pager: "false",
                    options: $setup.tabSlideOps
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.featuredProducts, (product) => {
                        return (_openBlock(), _createBlock(_component_ion_slide, {
                          key: product.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_product_card, {
                              product: product,
                              hideDetails: "true"
                            }, null, 8, ["product"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["options"])),
              _createElementVNode("h1", _hoisted_8, _toDisplayString($setup.t('HomePage.latestProducts')), 1),
              ($setup.loadingProducts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.latestProducts, (product) => {
                        return (_openBlock(), _createBlock(_component_ion_col, {
                          "size-xs": "6",
                          "size-md": "4",
                          "size-xl": "3",
                          key: product.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_product_card, {
                              product: product,
                              hideDetails: "true"
                            }, null, 8, ["product"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })),
              ($setup.loadingCompanyInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_card, { key: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ion_icon, {
                          class: "icon-xl",
                          icon: $setup.informationCircle,
                          color: "warning"
                        }, null, 8, ["icon"])
                      ]),
                      _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h1", null, _toDisplayString($setup.t('coachIntro')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coaches, (coach) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "6",
                              key: coach.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: "coach-card ion-text-center",
                                  onClick: ($event: any) => ($setup.openCoachModal(coach)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    (coach.photo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "coach-img",
                                          src: coach.photoLink
                                        }, null, 8, _hoisted_12))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_card_header, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_subtitle, { color: "dark" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(coach.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_card_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(coach.title), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}